export default __webpack_public_path__ + "static/media/help_selected.e504e4e2.svg";